<template>
  <div class="content">
    <el-input v-model="queryParams.serviceKey" placeholder="业务名称" clearable style="width: 210px"></el-input>
    <el-input v-model="queryParams.iccid" placeholder="ICCID/昵称" clearable style="width: 210px"></el-input>
    <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
    <el-button type="primary" icon="el-icon-refresh" @click="resetForm">重置</el-button>
    <div class="table" style="margin-top: 10px">
      <el-table :data="tableData" border v-loading="loading">
        <el-table-column prop="id" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="iccidOrUsername" label="ICCID/昵称" align="center"></el-table-column>
        <el-table-column prop="serviceKey" label="业务名称" align="center"></el-table-column>
        <el-table-column prop="number" label="执行次数" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="最后执行时间" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

  </div>
</template>
<script>
import { dataDictionaryRecordList} from "@/api/api.js"; //获取数据字典列表
export default {
  name: "source",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 搜索
      queryParams:{},
      page: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      //是否可以编辑
      disabled:false,
      // 表单参数
      form: {},
    };
  },
  computed: {},
  methods: {
    // 获取列表
    initData() {
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize
      };
      this.loading = true;
      dataDictionaryRecordList(params).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.loading = false;
        }else{
          this.$message.error("加载时间过长，请重新请求！");
          this.loading = false;
        }
      });
    },
    search(){
      this.page = 1,
      this.initData();
    },
    resetForm(){
      for (var i in this.queryParams) {
        this.queryParams[i] = null;
      };
      this.initData();
    },
    //表单重置
    reset(){
      this.form = {
        name: undefined,
        operationName: undefined,
        channel: undefined,
        status: '1',
        remark: undefined,
      };
      this.resetForm("form");
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
  },
  mounted() {
  },
  created(){
    this.initData();
  }
};
</script>
<style scoped lang="less">
.el-button {
  margin-left: 5px;
  border-radius: 3px;
  padding: 10px 20px;
}
</style>


